// eslint-disable-next-line import/prefer-default-export
export const MEDIA_TYPES = [
  { mimetype: 'image/jpeg', format: '.jpeg' },
  { mimetype: 'image/jpg', format: '.jpeg' },
  { mimetype: 'image/png', format: '.png' },
  { mimetype: 'image/svg+xml', format: '.svg' },
];
